function ThreeDTourLoad() {

	if ($('#3dtour-frame').length > 0 && !$('#3dtour-frame').hasClass('active')) {

		var $frameWrap = $('#3dtour-frame');
		var $frame = $frameWrap.find('iframe');
		var src = $frame.data('src');

		$frameWrap.on('click touch', function() {
			$frameWrap.addClass('active');
			$frame.prop('src', src);
		});
	}
}

$(document).ready(function() {
	ThreeDTourLoad();
});
